import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
} from "@mui/material";

interface WorkLogEntry {
  date: string;
  kilometersDone: number;
  clockIn: boolean;
  clockOut: boolean;
}

const WorkLogClock: React.FC = () => {
  const [entries, setEntries] = useState<WorkLogEntry[]>([
    { date: "2024-02-19", kilometersDone: 50, clockIn: false, clockOut: false }, // Example entry
  ]);

  const handleDateChange =
    (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const updatedEntries = [...entries];
      updatedEntries[index].date = event.target.value;
      setEntries(updatedEntries);
    };

  const handleKilometersChange =
    (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const updatedEntries = [...entries];
      updatedEntries[index].kilometersDone = parseInt(event.target.value, 10);
      setEntries(updatedEntries);
    };

  const handleButtonClick = (buttonName: string) => (index: number) => () => {
    const updatedEntries = [...entries];
    if (buttonName === "Clock In") {
      updatedEntries[index].clockIn = true;
    } else if (buttonName === "Clock Out") {
      updatedEntries[index].clockOut = true;
    }
    // Send data to backend API
    postDataToBackend(updatedEntries[index]);
    setEntries(updatedEntries);
  };

  const postDataToBackend = (entry: WorkLogEntry) => {
    // Example function to post data to backend API
    fetch("your-backend-api-url", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(entry),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        // Handle response
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  return (
   
    <TableContainer component={Paper} sx={{width:'80%', ml:'200px'}}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Kilometers Reading Now</TableCell>
            <TableCell>Clock In</TableCell>
            <TableCell>Clock Out</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {entries.map((entry, index) => (
            <TableRow key={index}>
              <TableCell>
                <TextField
                  type="date"
                  value={entry.date}
                  onChange={handleDateChange(index)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </TableCell>
              <TableCell>
                <TextField
                  type="number"
                  value={entry.kilometersDone}
                  onChange={handleKilometersChange(index)}
                />
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleButtonClick("Clock In")(index)}
                  disabled={entry.clockIn}
                >
                  Clock In
                </Button>
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleButtonClick("Clock Out")(index)}
                  disabled={entry.clockOut}
                >
                  Clock Out
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default WorkLogClock;
